export default __webpack_public_path__ + "static/media/FaqQuestionMark.ad0f371f.svg";